import React from 'react';
import { OutlineButton, Typography } from 'glints-aries/es/@next';
import { FormattedMessage } from 'react-intl';

import useOpenChatSupport from '../../../../common/hooks/useOpenChatSupport';

export const ContactUsButton = () => {
  const openChatSupport = useOpenChatSupport();
  return (
    <OutlineButton onClick={openChatSupport}>
      <Typography variant="button">
        <FormattedMessage
          id="interactive-contact-us"
          defaultMessage="Contact Us"
        />
      </Typography>
    </OutlineButton>
  );
};
